// extracted by mini-css-extract-plugin
export default {"table-header-spacer":"client-components-inventoryDetail-bodyPanes-workOrders-___assetWorkOrdersTable__table-header-spacer___1hrfJ"};